<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="bolt-on-discharge-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="bolt-on-discharge-search-view-table"
      @select="$emit('select', $event.data as Bolt_On_Discharges)"
    />
  </div>
</template>
<script setup lang="ts">
import { provide } from "vue";
import { useBoltOnDischarges } from "@/composables/equipment/boltOnDischarges/boltOnDischarges";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Bolt_On_Discharges } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Bolt_On_Discharges): void;
}>();

const boltOnDischargeSearch = useBoltOnDischarges(props.isAdmin);

provide("equipment", boltOnDischargeSearch);
</script>
